import { useEffect, useContext } from "react";
import { ApiContext } from "../../context/ApiContext";
import Button from "../../shared/Button";
import Loader from "../../shared/Loader";
import useStepData from "../../hooks/useStepData";
import Timeline from "../../shared/Timeline";
import MembershipSummary from "../../shared/MembershipSummary";
import { useNavigate } from "react-router-dom";
import __ from "../../utils/getContent";

const StepSummary = (): React.JSX.Element => {
	const { data, setData } = useContext(ApiContext);
	const navigate = useNavigate();
	const { error, loading, stepData } = useStepData(3);

	useEffect(() => {
		const packageIds: any[] = [];
		stepData?.get_packages?.StartStrongPackages?.forEach((item: any) => {
			packageIds.push(item.Id);
		});
		setData({
			...data,
			startstrongpackageids: packageIds,
		});
	}, [stepData, setData]); // eslint-disable-line react-hooks/exhaustive-deps

	if (loading) {
		return (
			<div className="flex min-h-[400px] items-center justify-center">
				<Loader colorCircle="#000" colorRotator="#ddd" />
			</div>
		);
	}

	if (error) {
		navigate("?step=contact&error=1");
	}

	return (
		<>
			<Timeline currentStep={3} />

			<div className="flex flex-col justify-center self-center text-center">
				<h1 className="mb-6 text-3xl font-bold uppercase">
					{__("membership_summary", "Membership Summary")}
				</h1>

				<p className="mb-10 max-w-screen-md">
					{__(
						"membership_summary_description",
						"Every new Midtown member starts with LAUNCH, our signature onboarding program. We’ve waived your LAUNCH fee so you can start building towards your personal aspirations for no additional charge.",
					)}
				</p>

				<MembershipSummary />

				<div className="flex w-full max-w-md items-end justify-end self-center">
					<Button
						action={() => {
							navigate("?step=details");
						}}
						isLoading={loading}
						cssClass="self-center mb-10"
						buttonType="button"
					>
						{__("button_text_continue_to_details", "Continue to Details")}
					</Button>
				</div>
			</div>
		</>
	);
};

export default StepSummary;
